export default "__VITE_ASSET__53faf24b__"